import { ImportantDialogOptions } from "@core-utils/important-dialog/models/important-dialog-options";

export const REMOVE_NEW_MATCHES_WITOUT_ACTIVITY_DIALOG_CONFIG: ImportantDialogOptions = {
    iconName: null,
    wraperClass: 'rpc-pick-list-confirm',
    panelClass: 'confirm-wrap--remove-nm',
    mainMessage: 'LISTING_MANAGEMENT_DIALOG.TITLES.REMOVE_NEW_MATCHES',
    additionalMessage: 'LISTING_MANAGEMENT_DIALOG.TITLES.WARNINGS.REMOVE_NEW_MACTH_WITHOUT_ACTIVITY',
    confirmButtonTitle: 'LISTING_MANAGEMENT_DIALOG.BUTTONS.REMOVE'
};